import { useShellBridgeStore } from "../stores"
import { getAmplitudeService } from "@/lib/services/amplitudeTrackingService";
import { getSplitService } from '@/lib/composable/split.io/splitClient' 
import { AppSnackbarProps } from "@maropost-ui/liquidsky-ui";

export async function trackAmplitudeEvent(
  eventName: string,
  eventProperties: Record<string, unknown> = {}
) {
  const amplitudeTrackingService = await getAmplitudeService();
  amplitudeTrackingService.trackEvent(eventName, eventProperties);
}

export const triggerSnackbar = (message: AppSnackbarProps) => {
  const shellBridgeStore = useShellBridgeStore();
  shellBridgeStore.setSnackbarMessage(message);
};

export async function splitKey (key:string, accountId:number){
  const { getSplitKey } = await getSplitService(accountId);
  return await getSplitKey(key)
}
